import { useContext, useEffect } from 'react';
import type { ISpinnerContext } from 'types/context/spinnerContext';
import { SpinnerWrapperContext } from 'ui/SpinnerWrapper';

const useShowSpinner = ({ show } = { show: false }) => {
  const { showSpinner } = useContext<ISpinnerContext>(SpinnerWrapperContext);

  // biome-ignore lint/correctness/useExhaustiveDependencies: pre-Biome migration; the app is already working as expected with these dependency arrays
  useEffect(() => {
    showSpinner(show);

    // If the owner unmounts while it is still showing the spinner (e.g. a tab
    // closed mid-load), hide it so the overlay isn't left on permanently.
    return () => {
      if (show) showSpinner(false);
    };
  }, [show]);
};

export default useShowSpinner;
